import GameButton from '@/shared/GameComponents/UI/GameAnswerButton/GameButton';
import { StyledFinalFeedback } from './FinalFeedback.styled';

export default function FinalFeedback({
  onRestart,
  progress,
  activityConf,
  questionsCount,
}) {
  const correctAnswers =
    (activityConf.correctness &&
      progress?.answers?.filter((answer) => answer.correct)) ||
    [];
  const allCorrect = correctAnswers.length == questionsCount;

  return (
    <StyledFinalFeedback>
      {activityConf.correctness ? (
        <>
          {allCorrect ? (
            <div className="feedback">
              <h3 className="title success">Congratulations!</h3>
              <div className="subtitle">
                You've successfully completed the game and got all answers right
              </div>
            </div>
          ) : (
            <div className="feedback">
              <h3 className="title">You've completed the game</h3>
              <div className="subtitle">
                You've answered {correctAnswers.length} out of {questionsCount}{' '}
                correctly
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="feedback">
          <h3 className="title">You've completed the game</h3>
        </div>
      )}
      <GameButton onClick={onRestart} type="primary">
        Play again
      </GameButton>
    </StyledFinalFeedback>
  );
}
